import '../style.scss';
import tooltip from '../tooltip';

export const mainTooltip = {
  ...tooltip
};
